export const formatQuantity = (value: number, decimalPlaces: number) => {
  if (value === 0) return 0;

  return Number(Number(value).toFixed(decimalPlaces));
};
